import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=3111a5ce&scoped=true"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"
import style0 from "./medical.vue?vue&type=style&index=0&id=3111a5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111a5ce",
  null
  
)

export default component.exports